"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickiesToolManager = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
class StickiesToolManager {
    constructor(store, sketch, bridge) {
        this.store = store;
        this.bridge = bridge;
        this.sketch = sketch;
    }
    addSticky(stickies) {
        var _a;
        if (!stickies.length) {
            return;
        }
        if (!Array.isArray(stickies)) {
            return;
        }
        const currentState = this.store.getState();
        if (!currentState) {
            return;
        }
        const updatedStickies = [
            ...(((_a = currentState === null || currentState === void 0 ? void 0 : currentState.stickiesState) === null || _a === void 0 ? void 0 : _a.stickies) || []),
            ...stickies,
        ];
        const lastSticky = stickies[stickies.length - 1];
        if (!lastSticky) {
            return;
        }
        const newStickiesState = Object.assign(Object.assign({}, currentState.stickiesState), { selectedStickyID: lastSticky.identifier, stickies: updatedStickies });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'stickiesState',
                changes: newStickiesState,
            },
        });
    }
    updateSticky(options) {
        var _a, _b;
        const currentState = this.store.getState();
        if (!currentState) {
            return;
        }
        const updatedStickies = (_b = (_a = currentState === null || currentState === void 0 ? void 0 : currentState.stickiesState) === null || _a === void 0 ? void 0 : _a.stickies) === null || _b === void 0 ? void 0 : _b.map(sticky => {
            if (sticky.identifier === options.identifier) {
                return Object.assign(Object.assign({}, sticky), { stickyRect: options.stickyRect
                        ? Object.assign(Object.assign({}, sticky.stickyRect), options.stickyRect) : sticky.stickyRect, text: options.text !== undefined ? options.text : sticky.text, curves: options.curves !== undefined ? options.curves : sticky.curves, image: options.image !== undefined ? options.image : sticky.image, videoUrl: options.videoLink !== undefined
                        ? options.videoLink
                        : sticky.videoLink });
            }
            return sticky;
        });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'stickiesState.stickies',
                changes: updatedStickies,
            },
        });
    }
    removeSticky(identifier) {
        const currentState = this.store.getState();
        if (!currentState) {
            return;
        }
        const updatedStickies = currentState.stickiesState.stickies.filter(sticky => sticky.identifier !== identifier);
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'stickiesState.stickies',
                changes: updatedStickies,
            },
        });
    }
    selectSticky(stickyID) {
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'stickiesState.selectedStickyID',
                changes: stickyID,
            },
        });
    }
    getStickiesState() {
        var _a;
        const screenWidth = document.body.offsetWidth;
        const screenHeight = document.body.offsetHeight;
        const state = this.store.getState();
        if (!state || !state.stickiesState) {
            return [];
        }
        const stickiesState = (_a = state.stickiesState.stickies) !== null && _a !== void 0 ? _a : [];
        return stickiesState.map(sticky => {
            var _a;
            return {
                type: sticky.type,
                identifier: sticky.identifier,
                height: sticky.stickyRect.height,
                width: sticky.stickyRect.width,
                savedWindowSize: [screenWidth, screenHeight],
                left: sticky.stickyRect.x,
                top: sticky.stickyRect.y,
                text: sticky.text,
                curvesArray: (_a = sticky.curves) === null || _a === void 0 ? void 0 : _a.map(curve => ({
                    size: curve.size,
                    points2D: curve.points,
                    color: curve.color,
                })),
                image: sticky.image,
                videoLink: sticky.videoLink,
                // image
                // imageSize
                // textScrollPosition
                // sizeIndex ??
            };
        });
    }
    setStickiesState(state) {
        const stickies = state.map((sticky) => {
            var _a;
            return {
                type: sticky.type,
                identifier: sticky.identifier,
                stickyRect: {
                    height: sticky.height,
                    width: sticky.width,
                    x: sticky.left,
                    y: sticky.top,
                },
                text: sticky.text,
                curves: ((_a = sticky === null || sticky === void 0 ? void 0 : sticky.curvesArray) === null || _a === void 0 ? void 0 : _a.map((curve) => {
                    return {
                        size: curve.size,
                        points: curve.points2D,
                        color: curve.color,
                    };
                })) || [],
                image: sticky.image,
                videoLink: sticky.videoLink,
            };
        });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'stickiesState.stickies',
                changes: stickies,
            },
        });
    }
    clearStickiesByType(type) {
        const currentState = this.store.getState();
        if (!currentState) {
            return [];
        }
        const filteredStickies = currentState.stickiesState.stickies.filter(sticky => sticky.type !== type);
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'stickiesState.stickies',
                changes: filteredStickies,
            },
        });
    }
    updateUndoRedoHistory() {
        var _a;
        (_a = this.bridge) === null || _a === void 0 ? void 0 : _a.addActionToHistory({
            state: {
                savedStickiesArray: this.getStickiesState(),
            },
        });
    }
    updateSketchOptions(options) {
        this.sketch.dispatch({
            type: 'toolsOptions/BridgeObjectChanged',
            payload: {
                identifier: 'toolsOptions',
                keyPath: 'sketchOptions',
                changes: options,
            },
        });
    }
    // eslint-disable-next-line max-lines-per-function
    renderHTMLToCanvas(ctx, element, x, y, lineHeight, padding) {
        let currentY = y;
        function renderNode(node, currentX, availableWidth) {
            var _a;
            if (node.nodeType === Node.TEXT_NODE) {
                // Render plain text
                const text = ((_a = node.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '';
                if (text) {
                    ctx.fillText(text, currentX, currentY);
                }
                currentY += lineHeight;
                return currentX + ctx.measureText(text).width;
            }
            else if (node.nodeType === Node.ELEMENT_NODE) {
                const el = node;
                ctx.save();
                // Apply inline styles
                const computedStyles = window.getComputedStyle(el);
                if (computedStyles.color)
                    ctx.fillStyle = computedStyles.color;
                if (computedStyles.fontSize)
                    ctx.font = `${ctx.font.split(' ')[0]} ${computedStyles.fontSize} ${ctx.font.split(' ')[2]}`;
                if (computedStyles.fontWeight)
                    ctx.font = `${computedStyles.fontWeight} ${ctx.font}`;
                if (computedStyles.fontStyle)
                    ctx.font = `${computedStyles.fontStyle} ${ctx.font}`;
                const textDecoration = computedStyles.textDecoration || '';
                // Apply specific styles based on element tag
                switch (el.tagName.toLowerCase()) {
                    case 'b':
                        ctx.font = `bold ${ctx.font}`;
                        break;
                    case 'i':
                        ctx.font = `italic ${ctx.font}`;
                        break;
                    case 'u':
                        ctx.textBaseline = 'bottom';
                        break;
                    case 'font': {
                        const color = el.getAttribute('color');
                        const size = el.getAttribute('size');
                        if (color)
                            ctx.fillStyle = color;
                        if (size)
                            ctx.font = `${parseInt(size, 10) * 4}px ${ctx.font.split(' ')[1]}`;
                        break;
                    }
                    default:
                        break;
                }
                // Handle underline explicitly
                if (el.tagName.toLowerCase() === 'u' ||
                    textDecoration.includes('underline')) {
                    const textWidth = ctx.measureText(el.textContent || '').width;
                    const underlineY = currentY + 2;
                    ctx.beginPath();
                    ctx.moveTo(currentX, underlineY);
                    ctx.lineTo(currentX + textWidth, underlineY);
                    ctx.strokeStyle = ctx.fillStyle;
                    ctx.lineWidth = 1;
                    ctx.stroke();
                }
                // Render child nodes recursively
                let newX = currentX;
                el.childNodes.forEach((childNode, index) => {
                    // Handle ordered and unordered lists
                    if (childNode.nodeType === Node.ELEMENT_NODE &&
                        childNode.tagName.toLowerCase() === 'li') {
                        currentY += 4; // Add spacing before the list
                        const listItem = childNode;
                        const bullet = el.tagName.toLowerCase() === 'ol' ? `${index + 1}.` : '•';
                        ctx.fillText(`${bullet} `, currentX + lineHeight, currentY);
                        newX = renderNode(listItem, currentX + ctx.measureText(`${bullet} `).width + lineHeight, availableWidth);
                        currentY += 4; // Add spacing after each list item
                    }
                    else {
                        newX = renderNode(childNode, newX, availableWidth);
                    }
                });
                ctx.restore();
                return newX;
            }
            return currentX;
        }
        // Iterate over child nodes of the main element
        element.childNodes.forEach(childNode => {
            renderNode(childNode, x, element.clientWidth - x - padding * 2);
        });
        return currentY;
    }
    screenshot() {
        var _a, _b, _c;
        // Create a canvas for the screenshot
        const canvasForScreenshot = document.createElement('canvas');
        const ctx = canvasForScreenshot.getContext('2d');
        if (!ctx) {
            console.error('Unable to create canvas context for screenshot.');
            return undefined;
        }
        const padding = 15;
        // Set canvas size to the current window size
        const interfaceSize = {
            width: window.innerWidth,
            height: window.innerHeight,
        };
        canvasForScreenshot.width = interfaceSize.width;
        canvasForScreenshot.height = interfaceSize.height;
        const stickiesState = (_c = (_b = (_a = this.store.getState()) === null || _a === void 0 ? void 0 : _a.stickiesState) === null || _b === void 0 ? void 0 : _b.stickies) !== null && _c !== void 0 ? _c : [];
        // Iterate through each sticky and render them on the canvas
        stickiesState.forEach(sticky => {
            var _a;
            if (!sticky.stickyRect)
                return;
            const { x, y, width, height } = sticky.stickyRect;
            ctx.fillStyle = '#21242b';
            ctx.fillRect(x, y, width, height);
            if ((sticky.type === bridge_schema_1.ToolType.StickyImage ||
                sticky.type === bridge_schema_1.ToolType.StickyVideo) &&
                sticky.image) {
                //image
                if (!sticky.image.includes('Cache')) {
                    (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.ContentManager.loadFileFromUrl(sticky.image, (result) => {
                        if (result) {
                            // Render image stickies
                            const image = new Image();
                            image.onload = () => {
                                ctx.drawImage(image, x, y, width, height);
                            };
                            const imageUrl = result.url.length === 0 ? result.path : result.url;
                            image.src = (0, ui_1.fixRelativeUrl)(imageUrl);
                        }
                        else {
                            console.error('Failed to load image from URL:', sticky.image);
                        }
                    }
                    // undefined, // No progress callback for now
                    // true, // Enable cache
                    //true, // Return URL
                    );
                }
                else {
                    // Render image stickies if cached
                    const image = new Image();
                    image.onload = () => {
                        ctx.drawImage(image, x, y, width, height);
                    };
                    image.src = (0, ui_1.fixRelativeUrl)(sticky.imageForScreenshot || sticky.image);
                }
                // // Render image stickies
                // const image = new Image();
                // image.onload = () => {
                //   ctx.drawImage(image, x, y, width, height);
                // };
                // image.src = fixRelativeUrl(sticky.image);
            }
            else if (sticky.type === bridge_schema_1.ToolType.StickyText && sticky.text) {
                // Render text stickies
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = sticky.text;
                const textNodes = tempDiv.childNodes;
                // Render the text content within the sticky's boundaries
                const lineHeight = 20;
                let currentY = y + padding + lineHeight;
                textNodes.forEach(node => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        // Render plain text
                        ctx.fillStyle = '#f3f3f3';
                        ctx.font = '16px Arial';
                        ctx.fillText(node.textContent || '', x + padding, currentY);
                        currentY += lineHeight + 4;
                    }
                    else if (node.nodeType === Node.ELEMENT_NODE) {
                        const element = node;
                        currentY = this.renderHTMLToCanvas(ctx, element, x + padding, currentY, lineHeight, padding);
                    }
                });
            }
            else if (sticky.type === bridge_schema_1.ToolType.StickyHandWriting && sticky.curves) {
                // Render handwriting stickies
                sticky.curves.forEach(curve => {
                    ctx.strokeStyle = curve.color || '#f3f3f3';
                    ctx.lineWidth = curve.size || 1;
                    ctx.beginPath();
                    curve.points.forEach((point, index) => {
                        if (index === 0) {
                            ctx.moveTo(point.x + x, point.y + y);
                        }
                        else {
                            ctx.lineTo(point.x + x, point.y + y);
                        }
                    });
                    ctx.stroke();
                });
            }
        });
        return canvasForScreenshot;
    }
}
exports.StickiesToolManager = StickiesToolManager;
